import { render, staticRenderFns } from "./CompInformationToTarif.vue?vue&type=template&id=6876fd52"
import script from "./CompInformationToTarif.vue?vue&type=script&lang=js"
export * from "./CompInformationToTarif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports